import script from "./DsAttendanceInfoSheetsCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./DsAttendanceInfoSheetsCard.vue?vue&type=script&setup=true&lang=ts"

import "./DsAttendanceInfoSheetsCard.vue?vue&type=style&index=0&id=2979c620&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2979c620"]])

export default __exports__